import { createFileRoute } from "@tanstack/react-router";

import { MyAccountPage } from "@/features/accounts/pages";

/**
 * One's own account: under administration (chapter 24), and out of its
 * guard, for every staff role acts on their own account (`settings_` keeps
 * the address and leaves the section's layout).
 */
export const Route = createFileRoute("/_app/settings_/account")({
  component: MyAccountPage,
});
